var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Text, Timestamp } from '@dixa/lib-shared-habla';
import * as React from 'react';
export const ConversationTimestamp = (_a) => {
    var { textProps } = _a, timestampProps = __rest(_a, ["textProps"]);
    return (_jsx(Text.Paragraph, Object.assign({ variant: "4", subdued: true }, textProps, { children: _jsx(Timestamp, Object.assign({ customFormatters: {
                absolute: 'D MMMM · HH:mm:ss',
                full: 'MMM D, YYYY · hh:mm:ss A',
            } }, timestampProps)) })));
};
